import React, { useState } from 'react';
import { Typography, CircularProgress, Grid, IconButton, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const HeatmapLegendBox = ({
  hideData,
  neighbourhoodAnalysisKey,
  neighbourhoodChoroplethLegends,
  loading,
  additionalStyle = {},
  defaultExpanded = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  if (hideData) return <></>;

  return (
    <Box
      style={{
        width: '200px',
        padding: isExpanded ? '10px 15px' : '5px 15px',
        background: 'white',
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
        borderRadius: 2,
        position: 'absolute',
        top: '10px',
        right: '10px',
        zIndex: 3,
        transition: 'all 0.3s ease',
        ...additionalStyle,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          See{' '}
          {
            {
              revenue: 'Revenue',
              occupancy: 'Occupancy Rate',
              listing: 'Supply',
            }[neighbourhoodAnalysisKey]
          }{' '}
          legends
          {loading && <CircularProgress size={20} />}
        </Typography>
        <IconButton size="small" onClick={() => setIsExpanded(!isExpanded)} sx={{ ml: 1 }}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isExpanded &&
        Object.keys(neighbourhoodChoroplethLegends)
          .reverse()
          .map(breakpoint => {
            if (!breakpoint.includes('undefined')) {
              return (
                <Grid container direction="row" style={{ marginTop: '10px' }} key={breakpoint}>
                  <div
                    style={{
                      width: '20px',
                      height: '20px',
                      background: neighbourhoodChoroplethLegends[breakpoint],
                      borderRadius: '10%',
                      border: '1px rgba(110.06, 110.06, 110.06, 0.32) solid',
                      marginRight: '10px',
                    }}
                  />
                  <Typography variant="body2">{breakpoint}</Typography>
                </Grid>
              );
            }
            return null;
          })}
    </Box>
  );
};

export default HeatmapLegendBox;
